import React from "react";
import Button from "./Button";

function CTA() {

  return (
    <div className="py-12 px-4 sm:px-6 sm:pb-20 lg:px-8 text-center max-w-6xl mx-auto">
      <h2 className="text-4xl leading-9 font-extrabold tracking-tight text-gray-900 sm:text-5xl sm:leading-10">
        Sign up now
      </h2>
      <p className="text-gray-700 my-8 text-xl lg:text-2xl font-body leading-7 text-gray-800 lg:mx-auto">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
      </p>
      <div className="my-8">
        <div className="inline-flex rounded-md shadow">
          <Button
            btnText="Get started"
            color="dark"
          />
        </div>
        <div className="ml-3 inline-flex rounded-md shadow">
          <Button
            btnText="Contact us"
            color="light"
          />
        </div>
      </div>
    </div>
  )
}

export default CTA;